"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ProviderBestGames = function (_a) {
    var provider = _a.provider, _b = _a.showGames, showGames = _b === void 0 ? true : _b, gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useCurrentProviderGames)({
        id: provider === null || provider === void 0 ? void 0 : provider.id,
    }).data;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.leftBlock },
            react_1.default.createElement(react_1.default.Fragment, null, (provider === null || provider === void 0 ? void 0 : provider.slug) ? (react_1.default.createElement("object", { className: styles_module_scss_1.default.providerImageObject, data: "/img/providers/".concat(provider === null || provider === void 0 ? void 0 : provider.slug, ".svg"), type: "image/png" },
                react_1.default.createElement("img", { src: "/img/providers/default.svg", alt: provider === null || provider === void 0 ? void 0 : provider.title }))) : null),
            react_1.default.createElement("br", null)),
        showGames && (react_1.default.createElement("div", { className: styles_module_scss_1.default.rightBlock },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('providersBestGames')),
            react_1.default.createElement(ui_components_1.OneRowGamesSlider, { title: provider === null || provider === void 0 ? void 0 : provider.title, games: data || [], gameCardPlaceholder: gameCardPlaceholder })))));
};
exports.default = react_1.default.memo(ProviderBestGames);
